import jwtDecode from 'jwt-decode';

const ID_TOKEN_KEY = 'id_token';
const ACCESS_TOKEN_KEY = 'access_token';
const REFRESH_TOKEN_KEY = 'refresh_token';
const ID_TOKEN_IPP = 'ipp';
class TokenService {
    getIdToken() {
        return localStorage.getItem(ID_TOKEN_KEY);
    }

    getIdTokenIpp() {
        return localStorage.getItem(ID_TOKEN_IPP);
    }

    setIdTokenIpp(ipp) {
        localStorage.setItem(ID_TOKEN_IPP, ipp);
    }
    
    setIdToken(idToken) {
        localStorage.setItem(ID_TOKEN_KEY, idToken);
    }
    
    clearIdToken() {
        localStorage.removeItem(ID_TOKEN_KEY);
    }

    getAccessToken() {
        return localStorage.getItem(ACCESS_TOKEN_KEY);
    }

    setAccessToken(accessToken) {
        localStorage.setItem(ACCESS_TOKEN_KEY, accessToken);
    }

    clearAccessToken() {
        localStorage.removeItem(ACCESS_TOKEN_KEY);
    }
    
    getRefreshToken() {
        return localStorage.getItem(REFRESH_TOKEN_KEY);
    }

    setRefreshToken(refreshToken) {
        localStorage.setItem(REFRESH_TOKEN_KEY, refreshToken);
    }

    clearRefreshToken() {
        localStorage.removeItem(REFRESH_TOKEN_KEY);
    }

    getTokenExpirationDate(encodedToken) {
        const token = jwtDecode(encodedToken);
        if (!token.exp) { return null; }
        const date = new Date(0);
        date.setUTCSeconds(token.exp);
        return date;
    }
  
    isTokenExpired(token) {
        const expirationDate = this.getTokenExpirationDate(token);
        return expirationDate < new Date();
    }
    

    idHeader() {
        let id_token = this.getIdToken();
        return id_token ? { Authorization: 'Bearer ' + id_token } : null;
    }  
    
    accessHeader() {
      let access_token = this.getAccessToken();
      return access_token ? { Authorization: 'Bearer ' + access_token } : null;
    }
    
   /*  async refreshAccessToken() {
        const response = await axios.post(`${API_URL}/token/refresh`, {headers: this.refreshHeader()})
        this.setAccessToken(response.data.access_token)
        return this.getAccessToken()
    }

    refreshHeader() {
         if(this.isTokenExpired(refresh_token)) {
            return {}
        } 
        return { Authorization: 'Bearer ' + this.getRefreshToken() }
    }
*/

}

export default new TokenService();